export default "__VITE_PUBLIC_ASSET__02b13a55__"